<template>
    <ul class="pagination pagination-sm justify-content-center">
        <li class="page-item" :class="{'disabled': currentPage===1}"><a class="page-link" href="#!"
                                                                       @click.prevent="changePage(1)">&lt;</a></li>
        <li class="page-item"
            v-for="n in pages"
            :key="`test${n}`"
            :class="{'disabled': (n-1)*limit === offset}"
            v-if="(n > currentPage - 4) && (n < currentPage + 4)"><a class="page-link" href="#!"
                                                                       @click.prevent="changePage(n)">{{n}}</a></li>
        <li class="page-item" :class="{'disabled': currentPage===pages}"><a class="page-link" href="#!"
                                                                           @click.prevent="changePage(pages)">&gt;</a></li>
    </ul>
</template>

<script>
    export default {
        name: "Paginator",
        props: {
            count: Number,
            limit: Number,
            offset: Number
        },
        computed: {
            pages() {
                return Math.ceil(this.count / this.limit)
            },
            currentPage() {
                return (this.offset / this.limit) + 1
            }
        },
        methods: {
            changePage(page) {
                this.$emit('changePage', page);
            }
        }
    }
</script>

<style scoped>

</style>
